/**
 * URLs that bypass the leave-site modal when opened.
 * Add entries here to allow direct navigation (new tab) without prompting.
 */
export const LEAVE_SITE_WHITELISTED_URLS = {
  SALESFORCE_HOMEPAGE: "https://www.salesforce.com",
  SLACK: "https://www.slack.com",
  TABLEAU: "https://www.tableau.com",
  INFORMATICA: "https://www.informatica.com",
  MULESOFT: "https://www.mulesoft.com",
  OWNDATA: "https://www.owndata.com",
  HEROKU: "https://www.heroku.com",
  SPIFF: "https://www.spiff.com",
  ZOOMINSOFTWARE: "https://www.zoominsoftware.com",
} as const;

const whitelistedUrlSet = new Set<string>(
  Object.values(LEAVE_SITE_WHITELISTED_URLS).map(normalizeLeaveSiteUrl)
);

/**
 * Normalize URL for whitelist comparison so that
 * https://www.salesforce.com, www.salesforce.com, and salesforce.com all match.
 */
export function normalizeLeaveSiteUrl(url: string): string {
  if (url == null) return "";
  let s = url.trim().toLowerCase();
  s = s.replace(/^(?:https?:\/\/)?/, ""); // strip http:// or https://
  s = s.replace(/^www\./, ""); // strip leading www.
  s = s.replace(/\/+$/, ""); // strip trailing slashes
  return s;
}

/**
 * Returns true if the URL is whitelisted and should open without showing the leave-site modal.
 */
export function isWhitelistedLeaveSiteUrl(url: string): boolean {
  return whitelistedUrlSet.has(normalizeLeaveSiteUrl(url));
}

export const REQUEST_LEAVE_SITE_MODAL_EVENT = "tbme_requestleavesitemodal";

/**
 * Request to leave the site for the given href.
 * If the URL is whitelisted, opens in a new tab immediately.
 * Otherwise dispatches an event so the leave-site modal shows.
 */
export function requestLeaveSite(href: string): void {
  if (isWhitelistedLeaveSiteUrl(href)) {
    window.open(href, "_blank", "noopener,noreferrer");
    return;
  }
  document.dispatchEvent(
    new CustomEvent(REQUEST_LEAVE_SITE_MODAL_EVENT, {
      detail: { href },
      bubbles: true,
      composed: true,
    })
  );
}
